// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a89363cc","453":"4623cbe7","455":"51911f95","977":"be12a07b"}[chunkId] + ".chunk.js";
};